import { useEffect, useState } from 'react';
import CreateIcon from '@mui/icons-material/Create';
import Modal from '@/trio-ui/Modal';
import Textarea from '@/trio-ui/Textarea';
import * as Styles from './AiOverviewModal.styles';

type AiOverviewModalProps = {
  isOpen: boolean;
  initialOverview: string;
  isSubmitting?: boolean;
  onSubmit: (updatedOverview: string) => void;
};

export default function AiOverviewModal({
  isOpen,
  initialOverview,
  isSubmitting = false,
  onSubmit,
}: AiOverviewModalProps): JSX.Element {
  const [overview, setOverview] = useState(initialOverview);

  useEffect(() => {
    if (isOpen) {
      setOverview(initialOverview);
    }
  }, [initialOverview, isOpen]);

  const onConfirmHandler = (): void => {
    onSubmit(overview.trim());
  };

  const Body = (
    <>
      <Styles.Label>
        This is an AI-generated overview of the candidate&apos;s profile and may contain mistakes;
        this is your only chance to edit it.
      </Styles.Label>
      <Styles.FieldWrapper>
        <Textarea
          id="ai-generated-overview"
          name="ai-generated-overview"
          value={overview}
          onChange={(event) => setOverview(event.target.value)}
        />
      </Styles.FieldWrapper>
    </>
  );

  return (
    <Modal
      modalId="ai-generated-overview-modal"
      isCentered
      size="lg"
      headerIcon={CreateIcon}
      modalTitle="Review AI-Generated Overview"
      onConfirmClick={onConfirmHandler}
      onConfirmLabel="Submit"
      isButtonDisabled={!overview.trim().length}
      bodyRender={Body}
      onClose={() => undefined}
      hideCancelButton
      isOpen={isOpen}
      isLoading={isSubmitting}
    />
  );
}
